

/// <reference path="ProxyPaymentTransaction.ts" />

// Generated class AdyenProxyPaymentTransaction_ManagedObject

class AdyenProxyPaymentTransaction_ManagedObject extends ProxyPaymentTransaction
{

    // Property: channel
    set channel(value:number) {
        this.setValueForKey(value, 'channel');
    }
    get channel():number {
        return this.valueForKey('channel');
    }
    set channelPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'channel');
    }
    get channelPrimitiveValue():number {
        return this.primitiveValueForKey('channel');
    }

    // Property: schemaCashDeskSessionDate
    set schemaCashDeskSessionDate(value:Date) {
        this.setValueForKey(value, 'schemaCashDeskSessionDate');
    }
    get schemaCashDeskSessionDate():Date {
        return this.valueForKey('schemaCashDeskSessionDate');
    }
    set schemaCashDeskSessionDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'schemaCashDeskSessionDate');
    }
    get schemaCashDeskSessionDatePrimitiveValue():Date {
        return this.primitiveValueForKey('schemaCashDeskSessionDate');
    }

    // Property: schemaCashDeskSessionID
    set schemaCashDeskSessionID(value:string) {
        this.setValueForKey(value, 'schemaCashDeskSessionID');
    }
    get schemaCashDeskSessionID():string {
        return this.valueForKey('schemaCashDeskSessionID');
    }
    set schemaCashDeskSessionIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'schemaCashDeskSessionID');
    }
    get schemaCashDeskSessionIDPrimitiveValue():string {
        return this.primitiveValueForKey('schemaCashDeskSessionID');
    }
}
